var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChatOnline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 16.009A4.002 4.002 0 0 1 15.994 12h12.012C30.215 12 32 13.8 32 16.009v7.982A4.002 4.002 0 0 1 28.006 28H17.5L12 32V16.009ZM14 28l2.5-2h11.506c1.1 0 1.994-.9 1.994-2.009V16.01A2.003 2.003 0 0 0 28.006 14H15.994c-1.1 0-1.994.9-1.994 2.009V28Zm3-8c0-.564.436-1 1-1 .564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1Zm4 0c0-.564.436-1 1-1 .564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1Zm4 0c0-.564.436-1 1-1 .564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1Z",
  fill: "#2D2D2D"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#1A8600",
  cx: 34,
  cy: 6,
  r: 4
}))));
export default SvgChatOnline;